<template>
	<div class="p-6 flex flex-col">
		<h2 class="text-3xl font-bold text-gray-900 mb-4">
			{{ __("Welcome") }}
			{{ user.name }},
			{{ __("glad you are here!") }}
		</h2>

		<div v-if="user.type == 'FARMER'" class="contents">
			<user-profile-status
				:user="user"
				:profileStatus="profileStatus"
			></user-profile-status>
		</div>

		<div v-else class="contents">
			<p class="mb-4">
				Bitte vervollständigen Sie Ihr Profil, damit es bald bei cropspot
				losgehen kann!
			</p>

			<div>
				<ui-button
					type="primary"
					class="whitespace-nowrap"
					v-on:click="continueToCompleteProfile()"
					>{{ __("Continue") }}</ui-button
				>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		user: {
			type: Object,
			required: true,
		},
		profileStatus: {
			type: Object,
		},
	},
	methods: {
		continueToCompleteProfile() {
			this.$bus.$emit(
				"toggle-iframe-modal",
				this.$route("user.complete_profile", { iframe_modal: true })
			);
		},
	},
};
</script>
